module.exports = __webpack_public_path__ + "static/img/jiaodai.12ff4f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jiaodai.png
// module id = B0rW
// module chunks = 1